import { Inbox } from "lucide-react";

export function EmptyState({ title, description, action, icon: Icon = Inbox, "data-testid": testId }) {
  return (
    <div
      data-testid={testId}
      className="border border-dashed border-border rounded-lg py-16 px-8 text-center bg-white"
    >
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-muted text-muted-foreground mb-5">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="text-lg mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-md mx-auto mb-6">{description}</p>
      )}
      {action}
    </div>
  );
}
